"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var lodash_1 = require("lodash");
var recompose_1 = require("recompose");
var AutoCompleteRemote_1 = __importDefault(require("./AutoCompleteRemote"));
var constants_1 = require("./Grid/constants");
var valueFunction = function (item) { return lodash_1.get(item, 'id'); };
var labelFunction = function (item) { return lodash_1.get(item, 'name'); };
var enhance = recompose_1.compose(recompose_1.defaultProps({ filterField: 'name', valueFilterField: 'id', params: {}, valueFunction: valueFunction, labelFunction: labelFunction }), recompose_1.withState('updateInput', 'setUpdateInput', undefined), recompose_1.withState('stateKey', 'setStateKey', true), recompose_1.withHandlers({
    updateStateKey: function (_a) {
        var stateKey = _a.stateKey, setStateKey = _a.setStateKey;
        return function () { return setStateKey(!stateKey); };
    },
}), recompose_1.withHandlers({
    onChange: function (_a) {
        var onChange = _a.onChange, updateStateKey = _a.updateStateKey, setUpdateInput = _a.setUpdateInput;
        return function (value) {
            if (!value) {
                setUpdateInput(undefined);
                updateStateKey();
            }
            onChange(value);
        };
    },
}), recompose_1.lifecycle({
    componentWillReceiveProps: function (nextProps) {
        if ((this.props.value && !nextProps.value) ||
            (this.props.value && nextProps.value && this.props.value !== nextProps.value && !lodash_1.isEmpty(nextProps.updateInput))) {
            this.props.setUpdateInput('');
            this.props.updateStateKey();
        }
        else if (nextProps.updateInput !== this.props.updateInput) {
            this.props.setUpdateInput(nextProps.updateInput);
        }
    },
}));
var AutoCompleteRemoteFilter = function (props) {
    var isMainFilter = props.isMainFilter, stateKey = props.stateKey, setStateKey = props.setStateKey, updateStateKey = props.updateStateKey, value = props.value, updateInput = props.updateInput, setUpdateInput = props.setUpdateInput, params = props.params, valueFilterField = props.valueFilterField, filterField = props.filterField, rest = __rest(props, ["isMainFilter", "stateKey", "setStateKey", "updateStateKey", "value", "updateInput", "setUpdateInput", "params", "valueFilterField", "filterField"]);
    return (React.createElement(AutoCompleteRemote_1.default, __assign({}, rest, { key: stateKey, clearOnBlur: false, filter: function () { return true; }, value: lodash_1.isEmpty(updateInput) && value ? value : updateInput, onUpdateInputChange: lodash_1.debounce(setUpdateInput, 300), params: (lodash_1.isEmpty(updateInput) && value) || !lodash_1.isEmpty(updateInput)
            ? __assign({}, params, { filter: lodash_1.compact(__spread(lodash_1.get(params, 'filter', []), [
                    lodash_1.isEmpty(updateInput) && value
                        ? {
                            field: valueFilterField,
                            operation: constants_1.FilterOperation.EQ,
                            value: value,
                        }
                        : !lodash_1.isEmpty(updateInput)
                            ? {
                                field: filterField,
                                operation: constants_1.FilterOperation.CONTAINS,
                                value: updateInput,
                            }
                            : null,
                ])) }) : params, onLoadData: function (items) {
            if (lodash_1.isEmpty(updateInput) && value) {
                var item = lodash_1.find(items, function (item) { return valueFunction(item) === value; });
                if (item) {
                    setUpdateInput(labelFunction(item));
                }
            }
        } })));
};
var ComposedAutoCompleteRemoteFilter = enhance(AutoCompleteRemoteFilter);
exports.default = ComposedAutoCompleteRemoteFilter;
//# sourceMappingURL=AutoCompleteRemoteFilter.js.map


//////////////////
// WEBPACK FOOTER
// .-core/es/components/controls/AutoCompleteRemoteFilter.js
// module id = 2114
// module chunks = 0